import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

function SectionLabel({ num, title }) {
  return (
    <div style={{ marginBottom: "1rem", paddingLeft: "clamp(0px, 15vw, 4.5rem)" }}>
      <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.accentBorder, letterSpacing: "4px", marginBottom: "0.6rem" }}>
        {num + " ───────────"}
      </div>
      <h2 style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "clamp(1.3rem,4vw,2.6rem)", color: "#fff" }}>
        {title}
      </h2>
    </div>
  );
}

export default function About() {
  return (
    <div className="anim-fadeup" style={{ padding: "4rem clamp(1.5rem,5vw,4rem)", maxWidth: "900px", margin: "0 auto" }}>
      <SectionLabel num="01" title="About Me" />

     <div className="about-grid" style={{ height: "1px", background: `linear-gradient(90deg, ${C.accentBorder}, transparent)`, marginBottom: "3rem", marginLeft: "clamp(0px, 15vw, 4.5rem)" }} />

      <div className="about-grid" style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "3rem", alignItems: "start" }}>
        <div>
          <div style={{ marginBottom: "2.5rem" }}>
            {DATA.about.split("\n\n").map((paragraph, i) => (
              <p key={i} style={{ fontFamily: FONT_MONO, fontSize: "clamp(0.85rem, 1.2vw, 1rem)", color: C.muted, lineHeight: 2.1, marginBottom: "1rem", textAlign: "justify" }}>
                {paragraph}
              </p>
            ))}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
            {[
              { icon: "📍", label: "Lokasi",   val: DATA.location },
              { icon: "📧", label: "Email",    val: DATA.email    },
              { icon: "💼", label: "LinkedIn", val: DATA.linkedin },
            ].map(({ icon, label, val }) => (
              <div key={label} style={{ display: "flex", gap: "1rem", alignItems: "center", fontFamily: FONT_MONO, fontSize: "0.83rem" }}>
                <span>{icon}</span>
                <span style={{ color: C.accentBorder, minWidth: "80px" }}>{label}</span>
                <span style={{ color: C.text }}>{val}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Profile Card */}
        <div className="about-card anim-float" style={{
          background: C.card, border: `1px solid ${C.accentBorder}`,
          borderRadius: "12px", padding: "2rem", textAlign: "center", minWidth: "200px",
        }}>
          <div style={{
            width: "88px", height: "88px", borderRadius: "50%",
            border: `2px solid ${C.accent}`,
            margin: "0 auto 1.5rem", overflow: "hidden",
          }}>
            <img
              src={DATA.foto}
              alt="Profile"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
          <div style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "1.1rem", color: "#fff", marginBottom: "0.4rem" }}>
            {DATA.name}
          </div>
          <div style={{ fontFamily: FONT_MONO, color: C.accent, fontSize: "0.72rem", letterSpacing: "2px", marginBottom: "1.5rem" }}>
            {DATA.title}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {["EMBEDDED SYSTEM", "IOT DAN MIKROKONTROLER", "ROBOTIKA"].map(tag => (
              <span key={tag} style={{
                background: C.accentDim, color: C.accent, border: `1px solid ${C.accentBorder}`,
                padding: "3px 0", borderRadius: "4px", fontSize: "0.68rem",
                letterSpacing: "2px", fontFamily: FONT_MONO,
              }}>{tag}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
